import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Trash2 } from "lucide-react";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { ConfirmDeleteDialog } from "@/components/admin/ConfirmDeleteDialog";

export const EmailList = ({ onChange }) => {
  const [emails, setEmails] = useState([]);
  const [target, setTarget] = useState(null);
  const [busy, setBusy] = useState(false);

  const load = () => api.get("/admin/emails").then((r) => setEmails(r.data));
  useEffect(() => { load(); }, []);

  const confirmDelete = async () => {
    setBusy(true);
    try {
      await api.delete(`/admin/emails/${target.id}`);
      toast.success(`${target.email} removed from the email list`);
      setTarget(null);
      load();
      onChange?.();
    } catch (e) { toast.error(apiError(e)); } finally { setBusy(false); }
  };

  return (
    <div className="space-y-2" data-testid="admin-email-list">
      {emails.map((e) => (
        <div key={e.id} className="silk-card rounded-lg px-4 py-3 flex flex-wrap items-center justify-between gap-3 text-sm" data-testid={`email-row-${e.id}`}>
          <span className={e.unsubscribed ? "text-muted-foreground line-through" : "text-foreground"}>{e.email}</span>
          <div className="flex items-center gap-3">
            <span className="text-xs text-muted-foreground">{e.source}{e.unsubscribed ? " · unsubscribed" : ""}</span>
            <Button size="sm" variant="ghost" className="rounded-full text-muted-foreground hover:text-foreground" data-testid={`email-delete-btn-${e.id}`} onClick={() => setTarget(e)}>
              <Trash2 size={13} className="mr-1.5" /> Delete
            </Button>
          </div>
        </div>
      ))}
      {emails.length === 0 && <p className="text-sm text-muted-foreground" data-testid="emails-empty">No emails captured yet.</p>}

      <ConfirmDeleteDialog open={!!target} onOpenChange={() => setTarget(null)} busy={busy} onConfirm={confirmDelete}
        testid="email-delete-dialog" title={`Remove ${target?.email} from the email list?`}
        description="They'll no longer receive newsletters. If they have an account, the account itself stays — only the email-list entry is removed. This can't be undone."
        confirmLabel="Remove email" cancelLabel="Keep email" />
    </div>
  );
};
